function Home() {
  return <h1>home</h1>;
}

export default Home;
